import { axiosRequest, axiosWithoutToken } from "../../../../service";
import { AILMENT_LIST, COVERAGE_TYPES, DOC_BULK_UPLOAD, DOCUMENT_TYPES, GENERATE_CLAIM, HEALTH_CLAIM_HISTORY, HEALTH_CLAIM_INGESTION, HEALTH_MASTER_SERVICE, HOSPITALIZATION_REASONS, KSHEMA_ENDORSEMENT, REACT_APP_KSHEMA_POC1, REACT_APP_KSHEMA_V2, REACT_APP_VAM_CONTEXT_DOCUMENT, REACT_APP_VAM_CONTEXT_INGESTION, REACT_APP_VAM_ENDPOINT, RELATIONS } from "../../../../urls";
import { FORM_KEYS, getPolicyMembers } from "./helper";
import { OTHERS } from "./HospitalizationDetails";
import { toast } from "react-toastify";
import { getFromDecreaptLocalStorage } from "../../../../utilFunctions";
import { getKshemaV2Token } from "../../../documentsIAGRI/apiHelper";

export const fetchCoverageTypes = async () => {
  try {
    const response = await axiosRequest().get(
      `${REACT_APP_VAM_ENDPOINT}/${HEALTH_MASTER_SERVICE}/${COVERAGE_TYPES}`
    );
    return response?.data?.coverageTypeList?.map((coverageType) => {
      return {
        label: coverageType.coverType,
        value: coverageType.coverageTypeId,
      };
    }); // return response.data
  } catch (error) {
    console.error("Error fetching coverage types:", error);
    throw error;
  }
};

export const fetchHospitalizationReasons = async () => {
  try {
    const response = await axiosRequest().get(
      `${REACT_APP_VAM_ENDPOINT}/${HEALTH_MASTER_SERVICE}/${HOSPITALIZATION_REASONS}`
    );
    return response?.data?.hospitalizationReasonList?.map((hospitalizationReason) => {
      return {
        label: hospitalizationReason.hospitalizationReason,
        value: hospitalizationReason.hospitalizationReasonId,
      };
    }); // return response.data
  } catch (error) {
    console.error("Error fetching hospitalization reasons:", error);
    throw error;
  }
};

export const fetchDocumentTypes = async () => {
  try {
    const response = await axiosRequest().get(
      `${REACT_APP_VAM_ENDPOINT}/${HEALTH_MASTER_SERVICE}/${DOCUMENT_TYPES}`
    );
    return response?.data?.requiredDocsList?.map((document) => {
      return {
        label: document.documentType,
        value: document.documentId,
      };
    }); // return response.data
  } catch (error) {
    console.error("Error fetching document types:", error);
    throw error;
  }
};

export const fetchRelations = async () => {
  try {
    const response = await axiosRequest().get(
      `${REACT_APP_VAM_ENDPOINT}/${HEALTH_MASTER_SERVICE}/${RELATIONS}`
    );
    return response?.data?.relationshipList?.map((relationship) => {
      return {
        label: relationship.relation,
        value: relationship.relationshipId,
      };
    }); // return response.data
  } catch (error) {
    console.error("Error fetching relations:", error);
    throw error;
  }
};

export const fetchAilmentTypes = async () => {
  try {
    const response = await axiosRequest().get(
      `${REACT_APP_VAM_ENDPOINT}/${HEALTH_MASTER_SERVICE}/${AILMENT_LIST}`
    );
    return response?.data?.ailmentList?.map((ailment) => {
      return {
        label: ailment.ailmentName,
        value: ailment.ailmentId,
      };
    }); // return response.data
  } catch (error) {
    console.error("Error fetching relations:", error);
    throw error;
  }
};
export const getLocationDetailsBasedOnVillageId=async(villageId)=>{
   try {
    const kshemaToken = await getKshemaV2Token()
    const response = await axiosWithoutToken().get(
      `${REACT_APP_KSHEMA_V2}/location-management-service/v1/villages/${villageId}`,
      {
        headers: {
          Authorization: `Bearer ${kshemaToken}`
        }
      }
    );
    return response.data?.data?.[0] 
    // return response.data
  } catch (error){
    if (error.status === 404 ) {
        toast.error("Invalid pincode.")
    }
    else {
      toast.error("Something Went Wrong.")
    }
    console.error(error)
  }
}

export const getLocationDetailsBasedOnPincode = async (pincode) => {
  try {
    const kshemaToken = getFromDecreaptLocalStorage("kshemaToken", true)
    const response = await axiosWithoutToken().get(
      `${KSHEMA_ENDORSEMENT}/villages/village-list?village=${pincode}&screenid=3&sourceid=999&childid=999`,
      {
        headers: {
          Authorization: `Bearer ${kshemaToken}`
        }
      }
    );
    return response.data
  } catch (error){
    if (error.status === 404 ) {
        toast.error("Invalid pincode.")
    }
    else {
      toast.error("Something Went Wrong.")
    }
    console.error(error)
  }
} 

export const uploadDocuments = async(proposalId, docType, files =[], setLoading) => {
  const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
              formData.append('files', files[i].file);
     }
    setLoading(true);
    const roleDataCookie = getFromDecreaptLocalStorage("roleData");
  const url =  `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_DOCUMENT}/${DOC_BULK_UPLOAD}?userId=${encodeURIComponent(roleDataCookie.userID)}&proposalId=${encodeURIComponent(proposalId)}&docType=${encodeURIComponent(docType)}&claimProduct=HospiCash`;
   try {
    const response = await axiosRequest().post(url, formData)
    setLoading(false)
    return response.data
   }
  catch(error){
    console.error(error);
    toast.error("Something Went Wrong.");
    setLoading(false)
  }
}

const getHospitalizationPayload = (formData) => {
  const payload = formData.hospitalizationDetails?.map((hospitalizationDetails,index) => {
    return {
      hospitalName: hospitalizationDetails[FORM_KEYS.hospital]?.value === OTHERS ? hospitalizationDetails[FORM_KEYS.hospital_name]: hospitalizationDetails[FORM_KEYS.hospital]?.value?.name ||hospitalizationDetails[FORM_KEYS.hospital]?.value?.hospitalName,
      hospitalCityPincode: "",
      numberOfDaysInICU: hospitalizationDetails[FORM_KEYS.icu_days] || 0,
      numberOfDaysInNonICU: hospitalizationDetails[FORM_KEYS.non_icu_days] || 0,
      totalDaysStay: "",
      doctorName: hospitalizationDetails[FORM_KEYS.doctor_name],
      doctorMobileNumber: hospitalizationDetails[FORM_KEYS.doctor_mobile_number],
      doctorRegistrationNumber: hospitalizationDetails[FORM_KEYS.doctor_registration_number],
      reasonForHospitalization: hospitalizationDetails[FORM_KEYS.reason_of_hospitalization]?.value,
      ailments: hospitalizationDetails[FORM_KEYS.ailment]?.map(ailment => ailment.value),
      diagnosisDescription: hospitalizationDetails[FORM_KEYS.description_of_diagnosis],
      admissionAt: hospitalizationDetails[FORM_KEYS.date_of_admission]+"T"+hospitalizationDetails[FORM_KEYS.time_of_admission]+":00+05:30",
      dischargeAt: hospitalizationDetails[FORM_KEYS.date_of_discharge] && hospitalizationDetails[FORM_KEYS.time_of_discharge] ? ( hospitalizationDetails[FORM_KEYS.date_of_discharge]+"T"+hospitalizationDetails[FORM_KEYS.time_of_discharge]+":00+05:30") : null,
      stateId: hospitalizationDetails[FORM_KEYS.state]?.value,
      stateName: hospitalizationDetails[FORM_KEYS.state]?.label,
      districtId: hospitalizationDetails[FORM_KEYS.district]?.value,
      mandalId: hospitalizationDetails[FORM_KEYS.mandal]?.value,
      villageId: hospitalizationDetails[FORM_KEYS.village]?.value,
      hospitalCityPincode: hospitalizationDetails[FORM_KEYS.pincode]
    }
  })
  return payload;
}

const getExistingPolicyPayload = (formData) => {
  let payload = [];
  if(formData[FORM_KEYS.have_other_policies] === "Yes") {
   payload= formData.existingPolicyDetails.map((policyDetails) => {
    return {
      policyId: policyDetails[FORM_KEYS.policy_number],
      insurerName: policyDetails[FORM_KEYS.insurer_name],
      sumInsured: policyDetails[FORM_KEYS.sum_insured],
      coverType: policyDetails[FORM_KEYS.coverage_type]?.value,
      policyValidityStart: policyDetails[FORM_KEYS.policy_start_date],
      policyValidityEnd: policyDetails[FORM_KEYS.policy_end_date]
    }
    })
  }
  return payload
}
const getDocumentsPayload = (formData) => {
  let payload = [];
   formData[FORM_KEYS.document_ids].map((document) => {
    if(document.docs.length) {
      document.docs.map(doc => {
        payload.push(doc.id)
      })
    }
  })
  return payload
}

export const generateClaim = async(formData, policyData, setShowClaimSuccessModal, setClaimID, setLoading)=> {
  const roleDataCookie = getFromDecreaptLocalStorage("roleData");
  const hospitalizationDetailsRequestList = getHospitalizationPayload(formData)
  const payload = {
    policyId: policyData.policy_no,
    customerId: policyData.customer_ref_id,
    policyType: policyData.policy_type,
    memberId: formData[FORM_KEYS.patient]?.value?.member_id || "",
    incidenceAt: formData[FORM_KEYS.date_of_incidence] + "T" + formData[FORM_KEYS.time_of_incidence] + ":00+05:30",
    policyHolderName: getPolicyMembers(policyData)?.[0]?.name,
    policyHolderMobileNumber: policyData.customer_mobile,
    healthClaimIntimationRequest:{
      claimIntimationType: formData[FORM_KEYS.intimated_by]?.value,
      intimatorName: formData[FORM_KEYS.intimator_name],
      relationshipWithPolicyHolderId: formData[FORM_KEYS.relationship]?.value,
      intimatorMobileNumber: formData[FORM_KEYS.intimator_mobile_number],
      channelId: 1, // Channel id for CMS is 1
      createdBy: roleDataCookie.userID,
    },
    patientDetailsRequest: {
      name: formData[FORM_KEYS.patient]?.value?.name,
      relationshipToPolicyholder: formData[FORM_KEYS.patient]?.value?.relation,
      dateOfBirth: formData[FORM_KEYS.patient]?.value?.dob,
      age: "",
      gender: formData[FORM_KEYS.patient]?.value?.gender,
      alternateMobileNumber: formData[FORM_KEYS.alternate_mobile_number]
    },
    hospitalizationDetailsRequestList : hospitalizationDetailsRequestList,
    otherExistingPolicyRequestList: getExistingPolicyPayload(formData),
    documents: getDocumentsPayload(formData),
    stateId: hospitalizationDetailsRequestList[0].stateId
  }
  setLoading(true);
  axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${HEALTH_CLAIM_INGESTION}/${GENERATE_CLAIM}`, payload).then(async data => {
        setClaimID(data?.data?.data)
        setShowClaimSuccessModal(true)
          }).catch(error => {
            console.error(error)
            toast.error("Something Went Wrong.")
          }).finally(()=>{
            setLoading(false)
          })
}

export const getClaimHistory = async (policyId, setLoading = () => {}) => {
  try {
    setLoading(true)
    const embeddedPolicyId = encodeURIComponent(policyId)
    const response = await axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${HEALTH_CLAIM_INGESTION}/${HEALTH_CLAIM_HISTORY}?policyId=${embeddedPolicyId}`)
    setLoading(false)
    return response.data;
  } catch (error){
    setLoading(false)
    console.error("error while getting the claim history", error)
  }
}